import { render, staticRenderFns } from "./TagRegister.vue?vue&type=template&id=1d58cdc4"
import script from "./TagRegister.vue?vue&type=script&lang=js"
export * from "./TagRegister.vue?vue&type=script&lang=js"
import style0 from "./TagRegister.vue?vue&type=style&index=0&id=1d58cdc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports